import Connection from './connection'
import PaginatedStore from './paginated_store'

export default class RecommendedListings extends PaginatedStore {
  constructor(scope) {
    super(new Connection('recommended_listings', scope))
  }

  create(data) {
    return this.connection.create(data)
      .then(resp => resp.data)
      .then(data => {
        this.records = [ ...(this.records || []), ...data ]
        return data
      })
  }
}



// WEBPACK FOOTER //
// client/stores/recommended_listings.js